var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, CustomElement, EventEmitter, Event, State, Interceptor, html, classMap, nothing } from '@sick-davinci/ce-decorators';
import { style } from './TextField.style';
/**
 * With a text field, users can enter or edit text. It's used to enter email addresses and passwords as well.
 * Text fields use a container to provide a clear affordance for interaction, making the fields discoverable in layouts.
 * 
 * @example
 * ```html
 * <davinci-text-field 
 *     label="Email" 
 *     placeholder="enter a valid email" 
 *     value="" 
 *     required
 *     pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" 
 *     title="must be a valid email">
 * </davinci-text-field>
 * ```
 */

export let TextField = (_dec = Component({
  tag: 'davinci-text-field',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = Prop({
  type: String
}), _dec21 = Reflect.metadata("design:type", typeof RegExp === "undefined" ? Object : RegExp), _dec22 = Prop(), _dec23 = Reflect.metadata("design:type", String), _dec24 = Prop({
  reflectAsAttribute: false
}), _dec25 = Reflect.metadata("design:type", String), _dec26 = State(), _dec27 = Reflect.metadata("design:type", Boolean), _dec28 = State(), _dec29 = Reflect.metadata("design:type", Boolean), _dec30 = Event(), _dec31 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec32 = Event(), _dec33 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec34 = Interceptor('pattern'), _dec35 = Reflect.metadata("design:paramtypes", [String, Object]), _dec36 = Interceptor('type'), _dec37 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = (_temp = class TextField extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "name", _descriptor, this);

    _initializerDefineProperty(this, "type", _descriptor2, this);

    _initializerDefineProperty(this, "label", _descriptor3, this);

    _initializerDefineProperty(this, "placeholder", _descriptor4, this);

    _initializerDefineProperty(this, "warning", _descriptor5, this);

    _initializerDefineProperty(this, "error", _descriptor6, this);

    _initializerDefineProperty(this, "required", _descriptor7, this);

    _initializerDefineProperty(this, "disabled", _descriptor8, this);

    _initializerDefineProperty(this, "readonly", _descriptor9, this);

    _initializerDefineProperty(this, "pattern", _descriptor10, this);

    _initializerDefineProperty(this, "title", _descriptor11, this);

    _initializerDefineProperty(this, "notEmpty", _descriptor12, this);

    _initializerDefineProperty(this, "isSelected", _descriptor13, this);

    _initializerDefineProperty(this, "change", _descriptor14, this);

    _initializerDefineProperty(this, "input", _descriptor15, this);

    this.internalValue = '';
    this.lastValue = '';

    this.blurTrap = event => {
      if (this.lastValue !== this.value) {
        this.emmitChangeEvent(event);
      }

      this.isSelected = false;
      this.shadowRoot.querySelector('.inputwrapper').classList.remove('focus-within');

      if (this.value === '') {
        this.notEmpty = false;
      } else {
        this.notEmpty = true;
      }
    };

    this.focusTrap = _event => {
      this.lastValue = this.value;
      this.isSelected = true;
      this.shadowRoot.querySelector('.inputwrapper').classList.add('focus-within');
    };

    this.changeTrap = event => {
      event.preventDefault();
      event.stopPropagation();
      this.internalValue = event.currentTarget.value;
    };

    this.inputTrap = event => {
      event.preventDefault();
      event.stopPropagation();
      this.internalValue = event.currentTarget.value;

      if (event.currentTarget.value === '') {
        this.notEmpty = false;
      } else {
        this.notEmpty = true;
      }

      this.input.emit(event.currentTarget.value);
    };

    this.keyUpTrap = event => {
      event.preventDefault();
      event.stopPropagation();

      if (event.key === 'Enter' && this.lastValue !== this.value) {
        this.lastValue = this.value;
        this.emmitChangeEvent(event);
      }
    };
  }

  /**
   * Set the value of the text field.
   */
  set value(val) {
    if (!val) {
      val = '';
    }

    if (val) {
      this.notEmpty = true;
    } else {
      this.notEmpty = false;
    }

    this.internalValue = val;
    this.testPattern(val);
  }

  get value() {
    return this.internalValue;
  }

  componentConnected() {
    super.componentConnected();
    this.testPattern(this.value);
  }

  render() {
    return html`
      <div class="inputwrapper ${classMap({
      notempty: this.value !== '' || this.notEmpty,
      selected: this.isSelected
    })}">
      <label class="label">${this.label}${this.required ? html` *` : nothing}</label>
        <div class="${classMap({
      input: true
    })}">
          <label class="placeholder">${this.placeholder}</label>
          <input .value="${this.value}"
            @blur="${this.blurTrap}"
            @focus="${this.focusTrap}"
            @change="${this.changeTrap}"
            @input="${this.inputTrap}"
            @keyup="${this.keyUpTrap}"
            type="${this.type}"
            ?disabled="${this.disabled}"
            ?readonly="${this.readonly}"></input>
        </div>
        <slot></slot>
      </div>
      <div class="message">
        <div class="warning">
          ${this.warning}
        </div>
        <div class="error">
          ${this.error}
        </div>
      </div>
    `;
  }

  interceptPattern(_oldValue, newValue) {
    if (typeof newValue === 'string') {
      return new RegExp(newValue);
    } else {
      if (!(newValue instanceof RegExp)) {
        return newValue = null;
      }
    }

    return newValue;
  }

  interceptType(_oldValue, newValue) {
    if (newValue !== 'text' && newValue !== 'password') {
      return 'text';
    }

    return newValue;
  }

  testPattern(val) {
    if (this.pattern) {
      if (this.pattern.test(val)) {
        this.removeAttribute('error');
      } else {
        this.error = this.title;
      }
    }
  }

  emmitChangeEvent(event) {
    const currentValue = event.currentTarget.value;

    if (this.pattern) {
      if (this.pattern.test(currentValue)) {
        this.change.emit(currentValue);
        this.removeAttribute('error');
      } else {
        this.error = this.title;
      }
    } else {
      this.change.emit(currentValue);
    }
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'text';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "placeholder", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "warning", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "error", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "required", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "readonly", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "pattern", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "notEmpty", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "isSelected", [_dec28, _dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec30, _dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec32, _dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "interceptPattern", [_dec34, _dec35], Object.getOwnPropertyDescriptor(_class2.prototype, "interceptPattern"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "interceptType", [_dec36, _dec37], Object.getOwnPropertyDescriptor(_class2.prototype, "interceptType"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=TextField.js.map